import React from "react";
import {
  Box,
  Container,
  Center,
  Flex,
  IconButton,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import { useNavigate, useParams } from "react-router-dom";
import {
  ReserveYourExperienceForm,
  usePub,
} from "@zillout/shared-components";
import { env } from "../config/env";
import { ZILLOUT_WEB_BASE_URL } from "../config/urls";
import { appendTrackingParams } from "../hooks/useTrackingSource";

export default function ReserveExperience() {
  const navigate = useNavigate();
  const { pub_id } = useParams<{ pub_id: string }>();
  const placeId = pub_id || env.REACT_APP_PLACE_ID;

  const { data: pub, isLoading } = usePub(placeId);
  const dayEvent = pub?.data?.day_event;
  const pubDetail = pub?.data?.pub_detail;

  const themePrimary: string =
    (pubDetail?.metaData?.theme as { primary?: string } | undefined)?.primary ??
    "#C9A26A";
  const pubColors = {
    bg: "#111111",
    text: "#FFFFFF",
    primary: themePrimary,
    secondary: "#A383FF",
    card_bg: "#1A1A1A",
    card_border: "#2B2B2B",
    icon_color: "white",
  };

  if (isLoading) {
    return (
      <Container maxW="100%" p="0" bg={pubColors.bg} minH="100vh">
        <Center h="100vh">
          <Spinner size="xl" color={pubColors.primary} />
        </Center>
      </Container>
    );
  }

  if (!dayEvent?.uuid || !placeId) {
    return (
      <Container maxW="100%" p="0" bg={pubColors.bg} minH="100vh">
        <Center h="100vh" px={6}>
          <Text color={pubColors.text} textAlign="center">
            No day-event reservation available.
          </Text>
        </Center>
      </Container>
    );
  }

  return (
    <Box w="100%" minH="100vh" bg={pubColors.bg} color={pubColors.text}>
      <Flex align="center" gap={3} px={4} py={4}>
        <IconButton
          aria-label="Go back"
          icon={<ChevronLeftIcon boxSize={6} />}
          onClick={() => navigate(-1)}
          bg={pubColors.card_bg}
          border={`1px solid ${pubColors.card_border}`}
          color={pubColors.text}
          borderRadius="10"
          size="md"
          _hover={{ bg: pubColors.primary }}
          _active={{ bg: pubColors.primary }}
        />
        <Text fontSize="md" fontWeight="600" color={pubColors.text}>
          {pubDetail?.name || "Reserve"}
        </Text>
      </Flex>

      <Container maxW="container.sm" pt={2} pb={10} px={4}>
        <ReserveYourExperienceForm
          pubId={placeId}
          dayEventUuid={dayEvent.uuid}
          onNavigate={(path) => {
            window.open(
              appendTrackingParams(`${ZILLOUT_WEB_BASE_URL}${path}`),
              "_self"
            );
          }}
          pubColors={pubColors}
        />
      </Container>
    </Box>
  );
}
